import React from 'react'
import { NavLink } from 'react-router-dom';

const NewsCard = ({item}) => {

  const {id, title, description,imageUrl, imageDescription} = item;

  return (
    <div className="max-w-md bg-white border border-gray-200 rounded-lg shadow">
      <NavLink to={'/news/' + id} className={'rounded-lg relative block w-full min-h-96 h-full max-h-96 overflow-hidden'}>
        <img className="rounded-t-lg absolute top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4" src={imageUrl} alt={imageDescription} />
      </NavLink>
      <div className="p-5">
        <a href="#">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900">{title}</h5>
        </a>
        <p className="mb-3 font-normal text-gray-700 line-clamp-3">{description}</p>
        <NavLink to={'/news/' + id} className="bg-primary px-4 py-2 text-white rounded-xl mt-2 md:mt-4 flex flex-row-reverse items-center gap-x-2 w-fit">
          <svg className="rtl:rotate-180 w-3.5 h-3.5 ms-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M1 5h12m0 0L9 1m4 4L9 9"/>
          </svg>
          قراءة المزيد
        </NavLink>
      </div>
    </div>
  )
}

export default NewsCard